var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm md:text-base",class:_vm.className},[(_vm.content)?_c('div',{staticClass:"wrap-text",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }